import { Link, LinkProps } from "@wootingkb/component-library";
import {
  ReplaceableKey,
  stringReplacer,
} from "../../lib/helper/stringReplacer";
import { useRegionalInstanceContext } from "../../lib/[services]/regional-instance";

export type ReplaceableURL = `${string}${ReplaceableKey}${string}`;

/**
 * Wrapper for WCL Link to do href replacing with regional instance awareness
 */
export default function RegionawareLink({
  children,
  href,
  ...props
}: LinkProps & { href: ReplaceableURL }) {
  const { id } = useRegionalInstanceContext();

  return (
    <Link {...props} href={href ? stringReplacer(href, id) : undefined}>
      {children}
    </Link>
  );
}
